import { Accordion, AccordionDetails, AccordionSummary, Backdrop, Box, Button, ButtonGroup, CircularProgress, Dialog, DialogContent, InputLabel, List, ListItem, Paper, Snackbar, Stack, Tab, Tabs, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import PerfectScrollbar from "react-perfect-scrollbar"
import "react-perfect-scrollbar/dist/css/styles.css"
import styles from '../../../../styles/pages/user/managerdashboard/manager-dashboard-pendingvdo.module.scss'
import videoImage from '../../../../public/assets/images/videoPageImg.png'
import ManagerPendingVideoFeatured from '../../../../components/ManagerPendingVideoFeatured/ManagerPendingVideoFeatured'
import CopyIndexIcon from '../../../../public/assets/icons/CopyIndexIcon'
import ApproveIcon from '../../../../public/assets/icons/ApproveIcon'
import WebsiteIcon from '../../../../public/assets/icons/WebsiteIcon'
import InquireIcon from '../../../../public/assets/icons/InquireIcon'
import RejectIcon from '../../../../public/assets/icons/RejectIcon'
import MessageLineIcon from '../../../../public/assets/icons/MessageLineIcon'
import DownloadVideoIcon from '../../../../public/assets/icons/DownloadVideoIcon'
import DownloadAgreement from '../../../../public/assets/icons/DownloadAgreement'
import VideoUrlIcon from '../../../../public/assets/icons/VideoUrlIcon'
import FileAttachIcon from '../../../../public/assets/icons/FileAttachIcon'
import AddPlusIcon from '../../../../public/assets/icons/AddPlusIcon'
import TextZoomIcon from '../../../../public/assets/icons/TextZoomIcon'
import BtnTickIcon from '../../../../public/assets/icons/BtnTickIcon'
import InfoIcon from '../../../../public/assets/icons/InfoIcon'
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import BtnCrossIcon from '../../../../public/assets/icons/BtnCrossIcon'
import { color } from '@mui/system'
import SolidCrrossIcon from '../../../../public/assets/icons/SolidCrrossIcon'
import Signature from '../../../../public/assets/images/signature.png'
import MinimizeIcon from '../../../../public/assets/icons/MinimizeIcon'
import ExpandMoreIcon from '../../../../public/assets/icons/ExpandMoreIcon'
import CalenderGrayIcon from '../../../../public/assets/icons/CalenderGrayIcon'
import ReadIcon from '../../../../public/assets/icons/ReadIcon'
import CrossIcon from '../../../../ui/Icons/CrossIcon'
import UploadPin from '../../../../ui/Icons/UploadPin'
import TrashIcon from '../../../../public/assets/icons/TrashIcon'
import PropTypes from 'prop-types'
import DownloadFileIcon from '../../../../public/assets/icons/DownloadFileIcon'
import XsCrossIcon from '../../../../public/assets/icons/XsCrossIcon'
import CancelBackIcon from '../../../../public/assets/icons/CancelBackIcon'
import NoteEditIcon from '../../../../public/assets/icons/NoteEditIcon'
import LongArrow from '../../../../ui/Icons/LongArrow'
import CopyvsidIcon from '../../../../public/assets/icons/CopyvsidIcon'
import MediaFile2Icon from '../../../../ui/Icons/MediaFile2Icon'
import DownloadStyled2Icon from '../../../../ui/Icons/DownloadStyled2Icon'
import View2Icon from '../../../../ui/Icons/View2Icon'
import ExclamatoryIcon from '../../../../ui/Icons/ExclamatoryIcon'

const OriginalVideoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} followCursor />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 237,
        borderRadius: "10px",
        color: "#000",
        boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
        padding: "9px 13px",
        [`& p`]: {
            color: "#000",
            fontSize: "12px",
            fontWeight: "500",
            lineHeight: "14px"
        }
    },
}));

const SocialVideoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} followCursor />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 237,
        borderRadius: "10px",
        color: "#000",
        boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
        padding: "9px 13px",
        [`& p`]: {
            color: "#000",
            fontSize: "12px",
            fontWeight: "500",
            lineHeight: "14px"
        }
    },
}));

const PostInfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 199,
        borderRadius: "10px 10px 0 10px",
        color: "#000",
        boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
        padding: "10px",
        margin: "0 !important"
    },
}));

const dialogContainer = {
    [`.MuiDialog-container`]: {
        alignItems: "flex-start",

        [`.MuiDialog-paper`]: {
            marginTop: "72px",
            boxShadow: "none",
            borderRadius: "10px !important",
            [`.MuiDialogContent-root`]: {
                padding: "0 11px"
            }
        }
    },
};

const inquierContainer = {
    [`.MuiDialog-container`]: {
        alignItems: "flex-start",

        [`.MuiDialog-paper`]: {
            marginTop: "62px",
            boxShadow: "none",
            borderRadius: "10px !important",
            [`.MuiDialogContent-root`]: {
                padding: "0 11px"
            }
        }
    },
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>{children}</>
            )}
        </Box>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const attachFileLoop = [
    {
        fileName: "5028537_5563370603774986.png"
    }
]

export default function VideoPending() {
    const [openProceed, setOpenProceed] = React.useState(false);
    const handleClickOpenProceed = () => {
        setOpenProceed(true);
    };

    const [value, setValue] = React.useState("");
    const [lisitem, setListItem] = React.useState([]);
    const [listIndex, setListIndex] = React.useState(-1);

    const addList = () => {
        setListItem([...lisitem, value]);
        setValue("");
    };

    const removeItem = (index) => {
        setListIndex(index);
    };

    useEffect(() => {
        const filterList = lisitem.filter((data, index) => index !== listIndex);
        setListItem(filterList);
        setListIndex(-1);
    }, [listIndex]);

    const [socialValue, setsocialValue] = React.useState("");
    const [socialLisitem, setsocialListItem] = React.useState([]);
    const [socialListIndex, setsocialListIndex] = React.useState(-1);

    const addListsocial = () => {
        setsocialListItem([...socialLisitem, value]);
        setsocialValue("");
    };

    const removeItemsocial = (index) => {
        setsocialListIndex(index);
    };

    useEffect(() => {
        const filterList = socialLisitem.filter((data, index) => index !== socialListIndex);
        setsocialListItem(filterList);
        setsocialListIndex(-1);
    }, [socialListIndex]);

    const [unreachable, setUnreachable] = useState(true)
    const [copywriteHighlight, setCopywriteHighlight] = useState(true)
    const [expanded, setExpanded] = React.useState(false);

    const handleChange =
        (panel) => (event, isExpanded) => {
            setExpanded(isExpanded ? panel : false);
        };

    const [modalopen, setModalopen] = React.useState(false);
    const [messagepertnerModal, setMessagepertnerModal] = React.useState(false)
    const [wesiteOnlyModal, setWesiteOnly] = React.useState(false)
    const [inquireModal, setInquireModal] = React.useState(false)
    const [videoreject, setVideoreject] = React.useState(false)
    const [rejection, setRejection] = React.useState(false)
    const [videoDuplicationYes, setvideoDuplicationYes] = React.useState(false)
    const [videoDuplicationNo, setvideoDuplicationNo] = React.useState(false)

    const handleClickOpen = () => {
        setModalopen(true);
    };

    const handleClose = () => {
        setModalopen(false);
    };

    const partnerModalOpen = () => {
        setMessagepertnerModal(true)
    }

    const partnerModalClose = () => {
        setMessagepertnerModal(false)
    }

    const inquireModalOpen = () => {
        setInquireModal(true)
    }
    const inquireModalClose = () => {
        setInquireModal(false)
    }

    const wesiteOnlyModalOpen = () => {
        setWesiteOnly(true)
    }
    const wesiteOnlyModalClose = () => {
        setWesiteOnly(false)
    }

    const videorejectModalOpen = () => {
        setVideoreject(true)
    }

    const videorejectClose = () => {
        setVideoreject(false)
    }

    const rejectionModalOpen = () => {
        setRejection(true)
    }

    const rejectionModalClose = () => {
        setRejection(false)
    }

    const videoDuplicationModalYesOpen = () => {
        setvideoDuplicationYes(true)
    }

    const videoDuplicationModalYesClose = () => {
        setvideoDuplicationYes(false)
    }

    const videoDuplicationModalNoOpen = () => {
        setvideoDuplicationNo(true)
    }

    const videoDuplicationModalNoClose = () => {
        setvideoDuplicationNo(false)
    }

    const [teamMsg, setTeamMsg] = React.useState(0);

    const handleTeamMsg = (event, newValue) => {
        setTeamMsg(newValue);
    };

    const [teamMsg1, setTeamMsg1] = React.useState(0);

    const handleTeamMsg1 = (event, newValue) => {
        setTeamMsg1(newValue);
    };

    const [snackOpen, setSnackOpen] = React.useState(false);

    const handleSnackbarClick = () => {
        setSnackOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackOpen(false);
    };

    const [websiteonlySnack, setWebsiteonlySnack] = React.useState(false);
    const [rejectSnack, setRejectSnack] = React.useState(false);
    const [rejectJustificationSnack, setRejectJustificationSnack] = React.useState(false);
    const [vdoduplicationSnack, setVdoduplication] = React.useState(false);

    const handleWebsiteonlyClick = () => {
        setWebsiteonlySnack(true);
    };

    const handleWebsiteonlyClose = () => {
        setWebsiteonlySnack(false);
    };

    const handleRejectClick = () => {
        setRejectSnack(true);
    };

    const handleRejectClose = () => {
        setRejectSnack(false);
    };

    const handleRejectJustificationClick = () => {
        setRejectJustificationSnack(true);
    };

    const handleRejectJustificationClose = () => {
        setRejectJustificationSnack(false);
    };

    const handlevdoduplicationSnackClick = () => {
        setVdoduplication(true);
    };

    const handlevdoduplicationSnackClose = () => {
        setVdoduplication(false);
    };

    const [vsidSuccess, setVsidSuccess] = React.useState(false);
    const textRef = useRef(null);
    const textRefPost = useRef(null);
    const handleCopyClick = () => {
        if (textRef.current) {
            textRef.current.select();
            try {
                document.execCommand('copy');
            } catch (err) {
                console.error('Unable to copy text: ', err);
            }
            window.getSelection().removeAllRanges();
        }
    };
    const handleCopyPostUrlClick = () => {
        if (textRefPost.current) {
            textRefPost.current.select();
            try {
                document.execCommand('copy');
            } catch (err) {
                console.error('Unable to copy text: ', err);
            }
            window.getSelection().removeAllRanges();
        }
    };

    const [alert, setAlert] = useState(true);
    const handleRemoveClick = () => {
        setAlert(false)
    }

    return (
        <>
            <Box className={styles.pageCopyVideo}>
                <PerfectScrollbar className={styles.videoDetailsScroll}>
                    <Stack
                        direction={"row"}
                        flexWrap={"wrap"}
                        className={styles.copywritterVideoWrapper}
                    >
                        <Box className={styles.videoColLeft}>
                            <Paper className={styles.vdoCard}>
                                <Box className={styles.videoBox} onClick={handleClickOpenProceed}>
                                    <img src={videoImage} width={701} height={435} alt="" />
                                    <ManagerPendingVideoFeatured />
                                </Box>
                                <Box className={styles.videoInput}>
                                    <input
                                        type="text"
                                        ref={textRef}
                                        value="Https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                                        readOnly
                                    />
                                    <Button onClick={handleCopyClick}>
                                        <CopyIndexIcon />
                                    </Button>
                                </Box>
                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.vdoDesBtngrp}>
                                    <Button startIcon={<ApproveIcon />} className={styles.btnApprove} onClick={handleSnackbarClick}>Approve</Button>
                                    <Button startIcon={<WebsiteIcon />} className={styles.btnWebsite} onClick={wesiteOnlyModalOpen}>Website Only</Button>
                                    <Button startIcon={<InquireIcon />} className={styles.btnInquire} onClick={inquireModalOpen}>Inquire</Button>
                                    <Button startIcon={<RejectIcon />} className={styles.btnReject} onClick={videorejectModalOpen}> Reject</Button>
                                </Stack>
                                <Stack
                                    direction={"row"}
                                    flexWrap={"wrap"}
                                    className={styles.vdobtnGrp}
                                >
                                    <Box className={styles.btnFristgrp}>
                                        <Button className={styles.msgcopyBtn} startIcon={<MessageLineIcon />} onClick={partnerModalOpen}>Message Partner</Button>
                                        <Button className={styles.msgcopyBtn} startIcon={<MessageLineIcon />}>Message Admin</Button>
                                        <Button className={styles.msgcopyBtn} startIcon={<MessageLineIcon />}>Message QC Agent</Button>
                                    </Box>
                                </Stack>
                                <Stack
                                    direction={"row"}
                                    flexWrap={"wrap"}
                                    className={styles.dwnldbtnGrp}>
                                    <Button className={styles.vdoDwnldBtn} startIcon={<DownloadVideoIcon />}>Download Video</Button>
                                    <Button className={styles.vdoagreeBtn} startIcon={<DownloadAgreement />}>Download Redacted Agreement</Button>
                                </Stack>
                            </Paper>
                            <Paper elevation={0} className={styles.assetPurchase}>
                                <Typography variant='body2'>Asset was purchased on behalf of ViralSnare by: <span>Arseny Dimirey</span> <small>(Content Buyer)</small></Typography>
                            </Paper>
                            <Paper className={`${styles.comWhiteBox} ${styles.titlePaperBox} ${styles.vdoDetailsCard}`}>
                                <Box className={styles.paperHeading}>
                                    <Typography variant="h2">
                                        <span>Video Details</span>
                                    </Typography>
                                </Box>
                                <Box className={styles.vdodetailInner}>
                                    <Box className={styles.vdoUrlGroup}>
                                        <Typography variant="caption" className={styles.formLabel}>Public Post URL</Typography>
                                        <Box className={styles.videoInput}>
                                            <input
                                                type="text"
                                                ref={textRefPost}
                                                value="Https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOVvvvv"
                                                readOnly
                                            />
                                            <Button onClick={handleCopyPostUrlClick}>
                                                <CopyIndexIcon />
                                            </Button>
                                        </Box>
                                    </Box>
                                    <Box className={styles.titleGroup}>
                                        <Typography variant="caption" className={styles.formLabel}>Title</Typography>
                                        <Typography variant="body2" className={styles.formPara}>Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away</Typography>
                                    </Box>
                                    <Box className={styles.descriptionGroup}>
                                        <Typography variant="caption" className={styles.formLabel}>Description:</Typography>
                                        <Typography variant="body2" className={styles.formPara}>Fusce eget lacus non turpis porttitor gravida sit amet quis tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis purus nisl, eu elementum risus faucibus vitae. Integmolestie, ex sit amet semd mauris odimolestie, met semd mauris odimolestie, ex sit amet semd maurier molestie, ex sit amet semd mauris odidgfgo... <Button><TextZoomIcon /></Button></Typography>
                                    </Box>
                                    <Stack direction={'row'} alignItems={'center'} className={styles.filmingGrid}>
                                        <Box className={`${styles.filmingLocaton} ${styles.Col}`}>
                                            <Typography variant="caption" className={styles.formLabel}>Filming Location</Typography>
                                            <Typography variant="body2" className={styles.formPara}>Los Angeles, California, United States</Typography>
                                        </Box>
                                        <Box className={`${styles.filmingDate} ${styles.Col}`}>
                                            <Typography variant="caption" className={styles.formLabel}>Filming Date</Typography>
                                            <Typography variant="body2" className={styles.formPara}>January 25, 2019</Typography>
                                        </Box>
                                    </Stack>
                                </Box>
                                <Box className={styles.vdoFileList}>
                                    <InputLabel>Original Video File(s)</InputLabel>
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                        <Box className={styles.linkBox}>
                                            <Typography variant='caption'>1.</Typography>
                                            <input type='text' value={value} onChange={(e) => setValue(e.target.value)} />
                                        </Box>
                                        <ButtonGroup>
                                            <Button onClick={addList}><AddPlusIcon /></Button>
                                            {/* <PostInfoTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Box className={styles.infoTooltip}>
                                                            <List disablePadding>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Added by:</InputLabel>
                                                                    <Typography variant='body2'>Partner/QC Agent/Member/Manager</Typography>
                                                                </ListItem>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Date:</InputLabel>
                                                                    <Typography variant='body2'>January 22, 2021 at 07:45 AM UTC</Typography>
                                                                </ListItem>
                                                            </List>
                                                        </Box>
                                                    </React.Fragment>
                                                }
                                            >
                                                <figure><InfoIcon /></figure>
                                            </PostInfoTooltip> */}
                                        </ButtonGroup>
                                    </Stack>
                                    <List disablePadding>
                                        {lisitem.map((data, index) => (
                                            <ListItem disablePadding key={index}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                                    <Box className={styles.linkBox}>
                                                        <Typography variant='caption'>{index + 2}.</Typography>
                                                        <input type='text' disabled {...data} />
                                                    </Box>
                                                    <ButtonGroup>
                                                        <Button>
                                                            <BtnTickIcon />
                                                        </Button>
                                                        <Button onClick={() => removeItem(index)}>
                                                            <BtnCrossIcon />
                                                        </Button>
                                                    </ButtonGroup>
                                                </Stack>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                                <Box className={styles.vdoFileList}>
                                    <InputLabel>Social Media Post(s)</InputLabel>
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                        <Box className={styles.linkBox}>
                                            <Typography variant='caption'>1.</Typography>
                                            <input type='text' value={socialValue} onChange={(e) => setsocialValue(e.target.value)} />
                                        </Box>
                                        <ButtonGroup>
                                            <Button onClick={addListsocial}><AddPlusIcon /></Button>
                                            {/* <PostInfoTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Box className={styles.infoTooltip}>
                                                            <List disablePadding>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Added by:</InputLabel>
                                                                    <Typography variant='body2'>Partner/QC Agent/Member/Manager</Typography>
                                                                </ListItem>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Date:</InputLabel>
                                                                    <Typography variant='body2'>January 22, 2021 at 07:45 AM UTC</Typography>
                                                                </ListItem>
                                                            </List>
                                                        </Box>
                                                    </React.Fragment>
                                                }
                                            >
                                                <figure><InfoIcon /></figure>
                                            </PostInfoTooltip> */}
                                        </ButtonGroup>
                                    </Stack>
                                    <List disablePadding>
                                        {socialLisitem.map((data, index) => (
                                            <ListItem disablePadding key={index}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                                    <Box className={styles.linkBox}>
                                                        <Typography variant='caption'>{index + 2}</Typography>
                                                        <input type='text' disabled {...data} />
                                                    </Box>
                                                    <ButtonGroup>
                                                        <Button>
                                                            <BtnTickIcon />
                                                        </Button>
                                                        <Button onClick={() => removeItemsocial(index)}>
                                                            <BtnCrossIcon />
                                                        </Button>
                                                    </ButtonGroup>
                                                </Stack>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                                <Box className={styles.mediaFilebtn}>
                                    <OriginalVideoTooltip
                                        title={
                                            <React.Fragment>
                                                <Typography color="inherit">Partner is currently adding a file.<br /> Please try again in a few minutes.</Typography>
                                            </React.Fragment>
                                        }
                                    >
                                        <Button startIcon={<VideoUrlIcon />}>Add original video file (VS Link)</Button>
                                    </OriginalVideoTooltip>
                                </Box>
                                <Box className={styles.mediaFilebtn}>
                                    <SocialVideoTooltip
                                        title={
                                            <React.Fragment>
                                                <Typography color="inherit">Partner is adding a post URL.<br /> Please try again in a few minutes.</Typography>
                                            </React.Fragment>
                                        }
                                    >
                                        <Button startIcon={<FileAttachIcon />}>Add social media post URL</Button>
                                    </SocialVideoTooltip>

                                </Box>
                            </Paper >
                        </Box >
                        <Box className={styles.videoColRight}>
                            {alert && <Box className={styles.pageMainAlert}>
                                <Typography variant='body1'>This video is <strong>pending</strong> review</Typography>
                                <Button className={styles.btnClose} onClick={handleRemoveClick}><SolidCrrossIcon /></Button>
                            </Box>}

                            <Box className={`${styles.pageMainAlert} ${styles.expandAlert}`}>
                                <Button className={styles.btnClose}><SolidCrrossIcon /></Button>
                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} justifyContent={'center'} className={styles.expandHeader}>
                                    <Typography variant='body1'><strong>You</strong> are <strong>Inquiring</strong> about this video</Typography>
                                    <Button><CancelBackIcon />Cancel</Button>
                                </Stack>
                                <Box className={styles.innerNotes}>
                                    <InputLabel>Your Notes <Button><NoteEditIcon /></Button></InputLabel>
                                    <List disablePadding className={styles.noteList}>
                                        <ListItem disablePadding>your notes will be shown here</ListItem>
                                        <ListItem disablePadding>your notes will be shown here</ListItem>
                                    </List>
                                </Box>
                            </Box>
                            <Box className={styles.cmnboxborderd}>
                                <Box className={`${styles.pageMainAlert} ${styles.approveAwating}`}>
                                    <Typography variant='body1'><span>You</span> <strong> approved</strong> this video on January 23, 2023 at 07:56:14 PM UTC.</Typography>
                                    <Button className={styles.alertbox_btn}>Awaiting Confirmation</Button>
                                    <Button className={styles.btnClose}><SolidCrrossIcon /></Button>
                                </Box>
                            </Box>
                            <Box className={styles.approveBox}>
                                <Typography variant='caption' className={styles.first_text}>Approved</Typography>
                                <Box className={styles.middle_div}>
                                    <Box className={styles.paperApprove}>
                                        <Typography variant='caption' className={styles.md_top_text}>?</Typography>
                                        <Typography variant='caption' className={styles.ico}>
                                            <LongArrow />
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography variant='caption' className={styles.last_text}>?</Typography>

                            </Box>
                            <Box className={styles.cmnboxborderd}>
                                <Stack direction={'row'} alignItems={'flex-start'} flexWrap={'wrap'} className={styles.approve_details_wrapper}>
                                    <Box className={`${styles.approveCol1} ${styles.Col2}`}>
                                        <Box className={styles.approve_details_left}>
                                            <Typography variant='body1' className={styles.app_lft_top}>
                                                Approved by:
                                                <Typography variant='caption' className={styles.name}>Theodore Doulke</Typography>
                                                <Typography variant='caption' className={styles.desg}>(Manager)</Typography>
                                            </Typography>
                                            <Typography variant='body1' className={styles.app_lft_btm}>
                                                Date:
                                                <Typography variant='caption' className={styles.date}>
                                                    March 23, 2023 at 05:14:23 PM UTC
                                                </Typography>
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.approveCol2} ${styles.Col2}`}>
                                        <Box className={`${styles.approve_details_rght} ${styles.disabled}`}>
                                            <Typography variant='caption' className={styles.confirm_text}>
                                                Awaiting Confirmation
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Stack>
                            </Box>
                            <Box className={styles.cmnboxborderd}>
                                <Box className={`${styles.pageMainAlert} ${styles.approveAwating}`}>
                                    <Typography variant='body1'><span>You</span> <strong> Rejected</strong> this video on January 23, 2023 at 07:56:14 PM UTC.</Typography>
                                    <Button className={styles.alertbox_btn}>Awaiting Confirmation</Button>
                                    <Button className={styles.btnClose}><SolidCrrossIcon /></Button>
                                </Box>
                            </Box>
                            <Box className={styles.approveBox}>
                                <Typography variant='caption' className={styles.first_text}>Rejected</Typography>
                                <Box className={styles.middle_div}>
                                    <Box className={styles.paperApprove}>
                                        <Typography variant='caption' className={styles.md_top_text}>?</Typography>
                                        <Typography variant='caption' className={styles.ico}>
                                            <LongArrow />
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography variant='caption' className={styles.last_text}>?</Typography>
                            </Box>
                            <Box className={styles.cmnboxborderd}>
                                <Stack direction={'row'} alignItems={'flex-start'} flexWrap={'wrap'} className={styles.approve_details_wrapper}>
                                    <Box className={`${styles.approveCol1} ${styles.Col2}`}>
                                        <Box className={styles.approve_details_left}>
                                            <Typography variant='body1' className={styles.app_lft_top}>
                                                Rejected by:
                                                <Typography variant='caption' className={styles.name}>Theodore Doulke</Typography>
                                                <Typography variant='caption' className={styles.desg}>(Manager)</Typography>
                                            </Typography>
                                            <Typography variant='body1' className={styles.app_lft_btm}>
                                                Date:
                                                <Typography variant='caption' className={styles.date}>
                                                    March 23, 2023 at 05:14:23 PM UTC
                                                </Typography>
                                            </Typography>
                                            <Box className={styles.justify_box}>
                                                <Box className={styles.justify_text}>
                                                    <Typography variant='h4'>Justification: <Button onClick={rejectionModalOpen}><NoteEditIcon /></Button></Typography>
                                                    <PerfectScrollbar className={styles.justificationScroll}>
                                                        <Typography variant='body1'>
                                                            Sapien ipsum. Euismod. Sagittis duis mus arcu conubia nostra erat augue ac enim massa blandit metus porttitor odio congue, amet per morbi. Hymenaeos volutpat cras. Suscipit ridiculus
                                                        </Typography>
                                                    </PerfectScrollbar>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.approveCol2} ${styles.Col2}`}>
                                        <Box className={`${styles.approve_details_rght} ${styles.disabled}`}>
                                            <Typography variant='caption' className={styles.confirm_text}>
                                                Awaiting Confirmation
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Stack>
                            </Box>
                            <Box className={styles.cmnboxborderd}>
                                <Box className={`${styles.pageMainAlert} ${styles.approveAwating}`}>
                                    <Typography variant='body1'><span>You</span> <strong> Approve</strong> this video for <strong>Website-only posting</strong> on January 23, 2023 at 07:56:14 PM UTC.</Typography>
                                    <Button className={styles.alertbox_btn}>Awaiting Confirmation</Button>
                                    <Button className={styles.btnClose}><SolidCrrossIcon /></Button>
                                </Box>
                            </Box>
                            <Box className={styles.approveBox}>
                                <Typography variant='caption' className={styles.first_text}>Website Only</Typography>
                                <Box className={styles.middle_div}>
                                    <Box className={styles.paperApprove}>
                                        <Typography variant='caption' className={styles.md_top_text}>?</Typography>
                                        <Typography variant='caption' className={styles.ico}>
                                            <LongArrow />
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography variant='caption' className={styles.last_text}>?</Typography>
                            </Box>
                            <Box className={styles.cmnboxborderd}>
                                <Stack direction={'row'} alignItems={'flex-start'} flexWrap={'wrap'} className={styles.approve_details_wrapper}>
                                    <Box className={`${styles.approveCol1} ${styles.Col2}`}>
                                        <Box className={styles.approve_details_left}>
                                            <Typography variant='body1' className={styles.app_lft_top}>
                                                Rejected by:
                                                <Typography variant='caption' className={styles.name}>Theodore Doulke</Typography>
                                                <Typography variant='caption' className={styles.desg}>(Manager)</Typography>
                                            </Typography>
                                            <Typography variant='body1' className={styles.app_lft_btm}>
                                                Date:
                                                <Typography variant='caption' className={styles.date}>
                                                    March 23, 2023 at 05:14:23 PM UTC
                                                </Typography>
                                            </Typography>
                                            <Box className={styles.justify_box}>
                                                <Box className={styles.justify_text}>
                                                    <Typography variant='h4'>Justification: <Button onClick={wesiteOnlyModalOpen}><NoteEditIcon /></Button></Typography>
                                                    <PerfectScrollbar className={styles.justificationScroll}>
                                                        <Typography variant='body1'>
                                                            Sapien ipsum. Euismod. Sagittis duis mus arcu conubia nostra erat augue ac enim massa blandit metus porttitor odio congue, amet per morbi. Hymenaeos volutpat cras. Suscipit ridiculus
                                                        </Typography>
                                                    </PerfectScrollbar>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.approveCol2} ${styles.Col2}`}>
                                        <Box className={`${styles.approve_details_rght} ${styles.disabled}`}>
                                            <Typography variant='caption' className={styles.confirm_text}>
                                                Awaiting Confirmation
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Stack>
                            </Box>
                            <Box className={`${styles.pageMainAlert} ${styles.flaggedAlert}`}>
                                <Typography variant='body1'><strong><b>You</b> flagged</strong> this video on February 15, 2022 at 07:45 AM UTC.</Typography>
                                <Button className={styles.btnClose}><SolidCrrossIcon /></Button>
                            </Box>
                            <Box className={vsidSuccess ? `${styles.accItems} ${styles.vsidAcc} ${styles.vsidAccSuccess}` : `${styles.accItems} ${styles.vsidAcc}`}>
                                <Accordion
                                    expanded={expanded === "vsid"}
                                    onChange={handleChange("vsid")}
                                >
                                    <AccordionSummary
                                        expandIcon={
                                            expanded === "vsid" ? <MinimizeIcon /> : <ExpandMoreIcon />
                                        }
                                        aria-controls="vsidbh-content"
                                        id="vsidbh-header"
                                    >
                                        {vsidSuccess ? <>
                                            <Typography variant="h2"><span>This video is good to go! It doesn't match any previous submissions</span></Typography>
                                        </>
                                            :
                                            <>
                                                <Typography variant="h2"><span>*Heads-up! We have received one or more submissions from this user:</span></Typography>
                                                <List disablePadding className={styles.vsidBtngroup}>
                                                    <ListItem>VSID 15645</ListItem>
                                                    <ListItem>VSID 15645</ListItem>
                                                    <ListItem>VSID 15645</ListItem>
                                                </List>
                                            </>
                                        }

                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <List disablePadding className={styles.vsidmatchList}>
                                            <ListItem>
                                                <Box className={styles.panelLeftItem}>
                                                    <Typography variant='body1' className={styles.titleText}>Does this submission doesn't match</Typography>
                                                    <Button endIcon={<CopyvsidIcon />} className={styles.btnPinkvsid}>VSID 15645</Button>
                                                    <Typography variant='body1'>?</Typography>
                                                </Box>
                                                <ButtonGroup>
                                                    <Button className={styles.yesAdd} onClick={videoDuplicationModalYesOpen}>Yes</Button>
                                                    <Button className={styles.noAdd} onClick={videoDuplicationModalNoOpen}>No</Button>
                                                </ButtonGroup>
                                            </ListItem>
                                            <ListItem>
                                                <Box className={styles.panelLeftItem}>
                                                    <Typography variant='body1' className={styles.titleText}>Does this submission doesn't match</Typography>
                                                    <Button endIcon={<CopyvsidIcon />} className={styles.btnPinkvsid}>VSID 15645</Button>
                                                    <Typography variant='body1'>?</Typography>
                                                </Box>
                                                <ButtonGroup>
                                                    <Button className={styles.yesAdd} onClick={videoDuplicationModalYesOpen}>Yes</Button>
                                                    <Button className={styles.noAdd} onClick={videoDuplicationModalNoOpen}>No</Button>
                                                </ButtonGroup>
                                            </ListItem>
                                            <ListItem>
                                                <Box className={styles.panelLeftItem}>
                                                    <Typography variant='body1' className={styles.titleText}>Does this submission doesn't match</Typography>
                                                    <Button endIcon={<CopyvsidIcon />} className={styles.btnPinkvsid}>VSID 15645</Button>
                                                    <Typography variant='body1'>?</Typography>
                                                </Box>
                                                <ButtonGroup>
                                                    <Button className={styles.yesAdd} onClick={videoDuplicationModalYesOpen}>Yes</Button>
                                                    <Button className={styles.noAdd} onClick={videoDuplicationModalNoOpen}>No</Button>
                                                </ButtonGroup>
                                            </ListItem>
                                        </List>
                                        <List disablePadding className={`${styles.vsidmatchList} ${styles.vsidmissMatchList}`}>
                                            <ListItem>
                                                <Box className={styles.panelLeftItem}>
                                                    <Box className={styles.vsMsgLeft}>
                                                        <Typography variant='body1' className={styles.titleText}>Submission doesn't match</Typography>
                                                    </Box>
                                                    <Box className={styles.vsBtnRight}>
                                                        <Button endIcon={<CopyvsidIcon />} className={`${styles.btnPinkvsid} ${styles.btnSuccessvsid}`}>VSID 15645</Button>
                                                    </Box>

                                                </Box>
                                            </ListItem>
                                            <ListItem>
                                                <Box className={styles.panelLeftItem}>
                                                    <Box className={styles.vsMsgLeft}>
                                                        <Typography variant='body1' className={styles.titleText}>Submission matches</Typography>
                                                    </Box>
                                                    <Box className={styles.vsBtnRight}>
                                                        <Button endIcon={<CopyvsidIcon />} className={styles.btnPinkvsid}>VSID 15645</Button>
                                                    </Box>

                                                </Box>
                                            </ListItem>
                                            <ListItem>
                                                <Box className={styles.panelLeftItem}>
                                                    <Box className={styles.vsMsgLeft}>
                                                        <Typography variant='body1' className={styles.titleText}>Submission doesn't match</Typography>
                                                    </Box>
                                                    <Box className={styles.vsBtnRight}>
                                                        <Button endIcon={<CopyvsidIcon />} className={`${styles.btnPinkvsid} ${styles.btnSuccessvsid}`}>VSID 15645</Button>
                                                    </Box>

                                                </Box>
                                            </ListItem>
                                        </List>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                            <Paper className={unreachable ? `${styles.comWhiteBox} ${styles.submitterDetails} ${styles.red_border}` : `${styles.comWhiteBox} ${styles.submitterDetails}`}>
                                <Box className={styles.paperHeading}>
                                    <Typography variant="h2">
                                        <span>Submitter Details</span>
                                    </Typography>
                                </Box>
                                <Stack direction={'row'} flexWrap={'wrap'} className={styles.ownerDetailsGrid}>
                                    <Box className={`${styles.gridCol1} ${styles.Col1}`}>
                                        <Box className={`${styles.formGroup} ${styles.formName}`}>
                                            <Typography variant="h6">Full Name</Typography>
                                            <Typography variant="body2">Saimon Jhonson</Typography>
                                        </Box>
                                        <Box className={`${styles.formGroup} ${styles.formNumber}`}>
                                            <Typography variant="h6">Phone Number</Typography>
                                            <Typography variant="body2">+1 234 567 8290</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridCol2} ${styles.Col1}`}>
                                        <Box className={`${styles.formGroup} ${styles.formEmail}`}>
                                            <Typography variant="h6">Email Address {unreachable ? <span className='unreach'>(Unreachable Email)</span> : ""}</Typography>
                                            <Typography variant="body2" className={styles.mailAdd}>jognsmith@gmail.com</Typography>
                                        </Box>
                                        <Box className={`${styles.formGroup} ${styles.formSocial}`}>
                                            <Typography variant="h6">Social Media Handle</Typography>
                                            <Typography variant="body2">Saimon Jhonson</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridCol3} ${styles.Col1}`}>
                                        <Box className={`${styles.formGroup} ${styles.formDob}`}>
                                            <Typography variant="h6">Date Of Birth</Typography>
                                            <Typography variant="body2">05/17/2002</Typography>
                                        </Box>
                                        <Box className={`${styles.formGroup} ${styles.formSignature}`}>
                                            <Typography variant="h6">Signature</Typography>
                                            <img src={Signature} alt="" className={styles.signature} />
                                        </Box>
                                        {/* <Box className={`${styles.formGroup} ${styles.formPdf}`}>
                                            <Stack direction={'row'} alignItems={'flex-start'} flexWrap={'wrap'} className={styles.ownerMedia}>
                                                <Box className={styles.mediaLeft}>
                                                    <MediaFile2Icon />
                                                </Box>
                                                <Box className={styles.mediaRight}>
                                                    <Typography variant="h5">Saimon Jhonson</Typography>
                                                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                        <Typography variant="caption">PDF</Typography>
                                                        <ButtonGroup>
                                                            <Button><DownloadStyled2Icon /></Button>
                                                            <Button className={styles.viewFiles}><View2Icon /></Button>
                                                        </ButtonGroup>
                                                    </Stack>
                                                </Box>
                                            </Stack>
                                        </Box> */}
                                    </Box>
                                </Stack>
                            </Paper>
                            <Paper className={copywriteHighlight ? `${styles.comWhiteBox} ${styles.copywright} ${styles.copywritePaperHighlight}` : `${styles.comWhiteBox} ${styles.copywright}`}>
                                <Box className={styles.paperHeading}>
                                    <Typography variant="h2">
                                        <span>Copyrights Ownership</span>
                                    </Typography>
                                </Box>
                                <List disablePadding className={styles.ownerListItme}>
                                    <ListItem disablePadding>
                                        <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                            <Box className={styles.listRowLeft}>
                                                <Typography variant='h4'>The person who filmed this video is </Typography>
                                                <Typography variant='body2'>Me</Typography>
                                            </Box>
                                        </Stack>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                            <Box className={styles.listRowLeft}>
                                                <Typography variant='h4'>Are There People Appearing In the Video? </Typography>
                                                <Typography variant='body2' className={styles.bgWrap}>No</Typography>
                                            </Box>
                                            {copywriteHighlight ? <>
                                                <Box className={`${styles.listRowRight}`}>
                                                    <Typography variant='h4'>Who are they? </Typography>
                                                    <Typography variant='body2' className={styles.textorng}>my friends</Typography>
                                                </Box>
                                            </> : ""}
                                        </Stack>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                            <Box className={styles.listRowLeft}>
                                                <Typography variant='h4'>Did You Send/Submit/Upload This Video To A Website And/Or Social Media Account? </Typography>
                                                <Typography variant='body2'>No, I did not</Typography>
                                            </Box>
                                        </Stack>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                            <Box className={styles.listRowLeft}>
                                                <Typography variant='h4'>Did Anyone Reach You About Using This Video?</Typography>
                                                <Typography variant='body2' className={styles.bgWrap}>No, You Are The First Company</Typography>
                                            </Box>
                                            {copywriteHighlight ? <>
                                                <Box className={`${styles.listRowRight}`}>
                                                    <Typography variant='h4'>Please share the name of the company/page with us</Typography>
                                                    <Typography variant='body2' className={styles.textorng}>Viralhog, jukin</Typography>
                                                </Box>
                                            </> : ""}
                                        </Stack>

                                    </ListItem>
                                    <ListItem disablePadding>
                                        <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                            <Box className={styles.listRowLeft}>
                                                <Typography variant='h4'>Did You Sign A Licensing Agreement For This Video With Another Company/Page?</Typography>
                                                <Typography variant='body2'>No, I Did Not</Typography>
                                            </Box>
                                        </Stack>
                                    </ListItem>
                                </List>
                            </Paper>
                            <Paper className={`${styles.comWhiteBox} ${styles.submissionInfo}`}>
                                <Box className={styles.paperHeading}>
                                    <Typography variant="h2">
                                        <span>Submission Information</span>
                                    </Typography>
                                </Box>
                                <Stack direction={'row'} flexWrap={'wrap'} className={styles.subInfoRow}>
                                    <Box className={`${styles.infoGrid1} ${styles.Col}`}>
                                        <Box className={styles.formGroup}>
                                            <Typography variant='h6'>Terms of Submission</Typography>
                                            <Typography variant='body2'>Agreed | Exclusive License</Typography>
                                        </Box>
                                        <Box className={styles.formGroup}>
                                            <Typography variant='h6'>User IP Address</Typography>
                                            <Typography variant='body2'>17.172.224.47</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.infoGrid2} ${styles.Col}`}>
                                        <Box className={styles.formGroup}>
                                            <Typography variant='h6'>Terms of Service</Typography>
                                            <Typography variant='body2'>Agreed</Typography>
                                        </Box>
                                        <Box className={styles.formGroup}>
                                            <Typography variant='h6'>Country</Typography>
                                            <Typography variant='body2'>United States</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.infoGrid3} ${styles.Col}`}>
                                        <Box className={styles.formGroup}>
                                            <Typography variant='h6'>Submission Date</Typography>
                                            <Typography variant='body2'>August 23, 2021 at 11:15:34 PM UTC</Typography>
                                        </Box>
                                        <Box className={styles.formGroup}>
                                            <Typography variant='h6'>Acquired By</Typography>
                                            <Typography variant='body2'>Acquisitor name</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.infoGrid4} ${styles.Col}`}>
                                        <Box className={styles.formGroup}>
                                            <Typography variant='h6'>VSID</Typography>
                                            <Typography variant='body2'>17171</Typography>
                                        </Box>
                                        <Box className={styles.formGroup}>
                                            <Typography variant='h6'>Revenue Share:</Typography>
                                            <Typography variant='body2'>50%</Typography>
                                        </Box>
                                    </Box>
                                </Stack>
                            </Paper>
                            <Box className={`${styles.accItems} ${styles.teamMsg}`}>
                                <Accordion
                                    expanded={expanded === "TeamMessages"}
                                    onChange={handleChange("TeamMessages")}
                                >
                                    <AccordionSummary
                                        expandIcon={
                                            expanded === "TeamMessages" ? <MinimizeIcon /> : <ExpandMoreIcon />
                                        }
                                        aria-controls="TeamMessagesbh-content"
                                        id="TeamMessagesbh-header"
                                    >
                                        <Typography variant="h2" sx={{ width: '35%', flexShrink: 0 }}><span>Team Messages</span></Typography>
                                        <Stack direction={'row'} alignItems={'center'} className={styles.teambtnGroup}>
                                            <Button>Partner</Button>
                                            <Button>Admin</Button>
                                            <Button>QC Agent</Button>
                                        </Stack>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box className={styles.teamMsgBtngroup}>
                                            <Tabs value={teamMsg} onChange={handleTeamMsg} aria-label="basic tabs example">
                                                <Tab label="Partner" {...a11yProps(0)} />
                                                <Tab label="Admin" {...a11yProps(1)} />
                                                <Tab label="QC Agent" {...a11yProps(2)} />
                                            </Tabs>
                                            <Box className={styles.tabPanelSec}>
                                                <CustomTabPanel value={teamMsg} index={0}>
                                                    <Box className={styles.tabpanelInner}>
                                                        <Typography variant='body1'>As <strong>you</strong> messaged the partner, you will be able to keep track of it by clicking here:</Typography>
                                                        <Button className={styles.openBtn}>Open <strong>Now</strong></Button>
                                                    </Box>
                                                </CustomTabPanel>
                                                <CustomTabPanel value={teamMsg} index={1}>
                                                    Item Two
                                                </CustomTabPanel>
                                                <CustomTabPanel value={teamMsg} index={2}>
                                                    Item Three
                                                </CustomTabPanel>
                                            </Box>
                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'} className={styles.tabsTopRoot}>
                                                <Tabs value={teamMsg1} onChange={handleTeamMsg1} aria-label="basic tabs example">
                                                    <Tab label="Partner" {...a11yProps(0)} />
                                                    <Tab label="Manager" {...a11yProps(1)} />
                                                    <Tab label="QC Agent" {...a11yProps(2)} className={styles.btnDot} />
                                                </Tabs>
                                                <Button className={styles.openBtn}>Respond <strong>Now</strong></Button>
                                            </Stack>
                                            <Box className={`${styles.tabPanelSec} ${styles.difTabPanel}`}>
                                                <CustomTabPanel value={teamMsg1} index={0}>
                                                    <Box className={styles.tabpanelInner}>
                                                        <Typography variant='body1'>Fusce eget lacus non turpis porttitor gravida sit amet quis tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis purus nisl, eu elementum risus faucibus vita. Integer molestie, ex sit amet semper aliquam, mauris odio dignissim velit, suscipit feugiat massa est varius lectus. Phasellus euismod lacinia tortor ac finibus. Maecenas semper consectetur venenatis. Nullam eget felis gravida, consectetur lacus nec, fermentum metus. Suspendisse ac tellus...</Typography>
                                                        <Box className={styles.fileListArea}>
                                                            <InputLabel>Added files:</InputLabel>
                                                            <List disablePadding>
                                                                {attachFileLoop.map((item) => {
                                                                    return (
                                                                        <ListItem disablePadding>
                                                                            <figure><DownloadFileIcon /></figure>
                                                                            <Typography variant='overline'>{item?.fileName}</Typography>
                                                                        </ListItem>
                                                                    );
                                                                })}

                                                            </List>
                                                        </Box>

                                                    </Box>
                                                </CustomTabPanel>
                                                <CustomTabPanel value={teamMsg1} index={1}>
                                                    Item Two
                                                </CustomTabPanel>
                                                <CustomTabPanel value={teamMsg1} index={2}>
                                                    Item Three
                                                </CustomTabPanel>
                                            </Box>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                            <Box className={`${styles.accItems} ${styles.noteSec}`}>
                                <Accordion
                                    expanded={expanded === "myNote"}
                                    onChange={handleChange("myNote")}
                                >
                                    <AccordionSummary
                                        expandIcon={
                                            expanded === "myNote" ? <MinimizeIcon /> : <ExpandMoreIcon />
                                        }
                                        aria-controls="myNotebh-content"
                                        id="myNotebh-header"
                                    >
                                        <Typography variant="h2"><span>Partner's Note</span></Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box className={styles.showNote}>
                                            <Box className={styles.readNote}>
                                                <Typography variant="body1">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, toSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, tdsmohas hfdibnf,d hgbdflk,mdffdo...</Typography>
                                                <Stack direction={'row'} flexWrap={'wrap'} alignItems={'center'} justifyContent={'space-between'} className={styles.noteBottmSec}>
                                                    <Box className={styles.noteDate}>
                                                        <CalenderGrayIcon />
                                                        <Typography variant="caption">January 25, 2023</Typography>
                                                    </Box>
                                                    <Stack direction={'row'} alignItems={'center'} className={styles.btnGrpStyled}>
                                                        <Button onClick={handleClickOpen}><ReadIcon /> Read</Button>
                                                    </Stack>
                                                </Stack>
                                            </Box>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        </Box >
                    </Stack >
                </PerfectScrollbar >
            </Box >

            <Dialog
                open={modalopen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "787px",
                        position: "relative",
                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent className={styles.readContent}>
                    <Box className={styles.readModalHeader}>
                        <Typography variant='h4'>Date: <Typography variant='caption'>January 25, 2023</Typography></Typography>
                        <Button onClick={handleClose}><CrossIcon /></Button>
                    </Box>
                    <Box className={styles.showNote}>
                        <Box className={styles.readNote}>
                            <Typography variant="body1">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, toSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, tdsmohas hfdibnf,d hgbdflk,mdffdo...</Typography>
                        </Box>
                    </Box>
                    <Box className={styles.readModalFooter}>
                        <Button onClick={handleClose}>Close</Button>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* ================================================== */}
            {/* ==========  MESSAGE PARTNER MODAL START  ========= */}
            {/* ================================================== */}
            <Dialog
                open={messagepertnerModal}
                onClose={partnerModalClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "787px",
                        position: "relative",
                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent className={`${styles.readContent} ${styles.msgPartnerContent}`}>
                    <Box className={styles.readModalHeader}>
                        <Typography variant='h3'>Message Partner</Typography>
                        <Typography variant='h4'>Date: <Typography variant='caption'>January 25, 2023 at 09:21 PM UTC</Typography></Typography>
                        <Button onClick={partnerModalClose}><CrossIcon /></Button>
                    </Box>
                    <Box className={styles.msgModalBody}>
                        <Box className={styles.ticket_form_modal}>
                            <Typography variant='h5' className={styles.modal_h5}>Is there something you would like to ask the partner about?</Typography>
                            <Box className={`${styles.status_messages_inputfrm} ${styles.textareas}`}>
                                <TextField multiline />
                            </Box>
                        </Box>
                        <Box className={styles.ticket_form_modal}>
                            <Box className={styles.attach_frm_messages}>
                                <Box className={styles.input_boxfile_attach}>
                                    <Box className={styles.input_boxfile_outer}>
                                        <Typography variant='caption'><i><UploadPin /></i> Attach a file</Typography>
                                    </Box>
                                    <TextField type='file' className={styles.file_uploaders} />
                                </Box>
                            </Box>
                            <Box className={styles.attach_frm_messages}>
                                <Stack direction={'row'} alignItems={'center'} className={styles.showAddFile}>
                                    <Button><TrashIcon /></Button>
                                    <span>screenshot.png</span>
                                </Stack>
                            </Box>
                            <Box className={styles.attach_frm_messages}>
                                <Stack direction={'row'} alignItems={'center'} className={styles.showAddFile}>
                                    <Button><TrashIcon /></Button>
                                    <span>325007798_724967765618154_1330143271608700845_n.png</span>
                                </Stack>
                                <Button className={styles.btnAddBlack}><AddPlusIcon /></Button>
                            </Box>
                            <Box className={styles.attach_frm_messages}>
                                <Box className={styles.input_boxfile_attach}>
                                    <Box className={`${styles.input_boxfile_outer} ${styles.input_selectFile}`}>
                                        <Typography variant='caption'><i><UploadPin /></i> Select file</Typography>
                                    </Box>
                                    <TextField type='file' className={styles.file_uploaders} />
                                </Box>
                                <Button className={`${styles.btnAddBlack} ${styles.roundBtn}`}><BtnCrossIcon /></Button>
                            </Box>
                        </Box>
                    </Box>
                    <Box className={styles.submit_sec_btns_foot}>
                        <Button className={styles.cancel_btn_modal} onClick={partnerModalClose}>Cancel</Button>
                        <Button className={styles.send_btn_modal}>Send <Typography variant='caption'>now</Typography></Button>
                    </Box>
                </DialogContent>
            </Dialog>
            {/* ================================================== */}
            {/* ===========  MESSAGE PARTNER MODAL END  ========== */}
            {/* ================================================== */}

            {/* ================================================== */}
            {/* ===============  INQUIRE MODAL START ============= */}
            {/* ================================================== */}
            <Dialog
                open={inquireModal}
                onClose={inquireModalClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "473px",
                        position: "relative",
                    }
                }}
                sx={inquierContainer}
            >
                <DialogContent className={`${styles.readContent} ${styles.inquireContent}`}>
                    <Box className={styles.inquireModalBody}>
                        <Button className={styles.modalClose} onClick={inquireModalClose}><CrossIcon /></Button>
                        <InputLabel>What would you like to inquire about?</InputLabel>
                        <Box className={styles.inputGroup}>
                            <Button><XsCrossIcon /></Button>
                            <TextField multiline />
                            <Typography variant='overline'>70 charachters left.</Typography>
                        </Box>
                        <ButtonGroup className={styles.modalFooterBtn}>
                            <Button className={styles.btnSave}>Save</Button>
                            <Button className={styles.btnCancel}>Cancel</Button>
                        </ButtonGroup>
                    </Box>
                </DialogContent>
            </Dialog>
            {/* ================================================== */}
            {/* ================  INQUIRE MODAL END ============== */}
            {/* ================================================== */}

            {/* ================================================== */}
            {/* ============  VIDEO REJECT MODAL START  ========== */}
            {/* ================================================== */}
            <Dialog
                open={videoreject}
                onClose={videorejectClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "787px",
                        position: "relative",
                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent className={`${styles.readContent} ${styles.msgPartnerContent} ${styles.confrmRejectContent}`}>
                    <Box className={styles.readModalHeader}>
                        <Typography variant='h3'>Video Rejection</Typography>
                        <Typography variant='h4'>Date: <Typography variant='caption'>January 25, 2023 at 09:21 PM UTC</Typography></Typography>
                        <Button onClick={videorejectClose}><CrossIcon /></Button>
                    </Box>
                    <Box className={styles.msgModalBody}>
                        <Box className={styles.ticket_form_modal}>
                            <Typography variant='h5' className={styles.modal_h5}>Kindly inform the partner of the reasoning behind the rejection of this video.</Typography>
                            <Box className={`${styles.status_messages_inputfrm} ${styles.textareas}`}>
                                <TextField multiline />
                            </Box>
                        </Box>
                    </Box>
                    <Box className={styles.submit_sec_btns_foot}>
                        <Button className={styles.cancel_btn_modal} onClick={videorejectClose}>Cancel</Button>
                        <Button className={`${styles.send_btn_modal} ${styles.confrmRejectBtn}`} onClick={handleRejectClick}>Confirm Rejection</Button>
                    </Box>
                </DialogContent>
            </Dialog>
            {/* ================================================== */}
            {/* =============  VIDEO REJECT MODAL END  =========== */}
            {/* ================================================== */}

            {/* ================================================== */}
            {/* =============  WEBSITEONLY MODAL START =========== */}
            {/* ================================================== */}
            <Dialog
                open={wesiteOnlyModal}
                onClose={wesiteOnlyModalClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "473px",
                        position: "relative",
                    }
                }}
                sx={inquierContainer}
            >
                <DialogContent className={`${styles.readContent} ${styles.inquireContent}`}>
                    <Box className={styles.inquireModalBody}>
                        <Button className={styles.modalClose} onClick={wesiteOnlyModalClose}><CrossIcon /></Button>
                        <InputLabel>Why should this video be approved for Website Only posting?</InputLabel>
                        <Box className={styles.inputGroup}>
                            <Button><XsCrossIcon /></Button>
                            <TextField multiline />
                            <Typography variant='overline'>70 charachters left.</Typography>
                        </Box>
                        <ButtonGroup className={styles.modalFooterBtn}>
                            <Button className={styles.btnSave} onClick={handleWebsiteonlyClick}>Proceed</Button>
                            <Button className={styles.btnCancel}>Cancel</Button>
                        </ButtonGroup>
                    </Box>
                </DialogContent>
            </Dialog>
            {/* ================================================== */}
            {/* ==============  WEBSITEONLY MODAL END ============ */}
            {/* ================================================== */}

            {/* ================================================== */}
            {/* =====  REJECTION JUSTIFICATION MODAL START  ====== */}
            {/* ================================================== */}
            <Dialog
                open={rejection}
                onClose={rejectionModalClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "787px",
                        position: "relative",
                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent className={`${styles.readContent} ${styles.msgPartnerContent} ${styles.rejectJustifyContent}`}>
                    <Box className={styles.readModalHeader}>
                        <Typography variant='h3'>Rejection Justification</Typography>
                        <Button onClick={rejectionModalClose}><CrossIcon /></Button>
                    </Box>
                    <Box className={styles.msgModalBody}>
                        <Box className={styles.ticket_form_modal}>
                            <Box className={`${styles.status_messages_inputfrm} ${styles.textareas}`}>
                                <TextField multiline />
                            </Box>
                        </Box>
                    </Box>
                    <Box className={styles.submit_sec_btns_foot}>
                        <Button className={styles.cancel_btn_modal} onClick={rejectionModalClose}>Cancel</Button>
                        <Button className={`${styles.send_btn_modal}`} onClick={handleRejectJustificationClick}>Save</Button>
                    </Box>
                </DialogContent>
            </Dialog>
            {/* ================================================== */}
            {/* ======  REJECTION JUSTIFICATION MODAL END  ======= */}
            {/* ================================================== */}

            {/* ================================================== */}
            {/* ====  FOR YES VIDEO DUPLICATION MODAL START  ===== */}
            {/* ================================================== */}
            <Dialog
                open={videoDuplicationYes}
                onClose={videoDuplicationModalYesClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "473px",
                        position: "relative",
                    }
                }}
                sx={inquierContainer}
            >
                <DialogContent className={`${styles.readContent}`}>
                    <Box className={styles.vdoDuplicationModalBody}>
                        <Button onClick={videoDuplicationModalYesClose} className={styles.modalCrossClose}><CrossIcon /></Button>
                        <figure><ExclamatoryIcon /></figure>
                        <Typography variant='h3'>Are you sure you want to flag this video as duplicate?</Typography>
                        <Typography variant='body1'>This action cannot be undone.</Typography>
                        <ButtonGroup className={styles.modalFooterBtn}>
                            <Button className={styles.btnSave} onClick={handlevdoduplicationSnackClick}>Confirm</Button>
                            <Button className={styles.btnCancel}>Cancel</Button>
                        </ButtonGroup>
                    </Box>
                </DialogContent>
            </Dialog>
            {/* ================================================== */}
            {/* =====  FOR YES VIDEO DUPLICATION MODAL END  ====== */}
            {/* ================================================== */}

            {/* ================================================== */}
            {/* =====  FOR NO VIDEO DUPLICATION MODAL START  ===== */}
            {/* ================================================== */}
            <Dialog
                open={videoDuplicationNo}
                onClose={videoDuplicationModalNoClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "473px",
                        position: "relative",
                    }
                }}
                sx={inquierContainer}
            >
                <DialogContent className={`${styles.readContent}`}>
                    <Box className={styles.vdoDuplicationModalBody}>
                        <Button onClick={videoDuplicationModalNoClose} className={styles.modalCrossClose}><CrossIcon /></Button>
                        <figure><ExclamatoryIcon /></figure>
                        <Typography variant='h3'>Are you sure this video is not a match?</Typography>
                        <Typography variant='body1'>This action cannot be undone.</Typography>
                        <ButtonGroup className={styles.modalFooterBtn}>
                            <Button className={styles.btnSave} onClick={handlevdoduplicationSnackClick}>Confirm</Button>
                            <Button className={styles.btnCancel}>Cancel</Button>
                        </ButtonGroup>
                    </Box>
                </DialogContent>
            </Dialog>
            {/* ================================================== */}
            {/* ======  FOR NO VIDEO DUPLICATION MODAL END  ====== */}
            {/* ================================================== */}

            {/* ======================= */}
            {/* ===== FOR APPROVE ===== */}
            {/* ======================= */}

            <Backdrop
                open={snackOpen}
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                onClick={handleSnackbarClose}
            >
                <Snackbar
                    open={snackOpen}
                    autoHideDuration={100000}
                    onClose={handleSnackbarClose}
                    message={
                        <>
                            <CircularProgress size={20} thickness={7} color="inherit" />
                            <span className='textSave'>Saving</span>
                            {/* <p className='textSave textSaveTwo'>Video   <span className='textSaveSpan'> Approved</span> -  Pending Verification</p> */}
                        </>
                    }
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    ContentProps={{
                        sx: {
                            minWidth: "219px !important",
                            background: "#000",
                            boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                            height: "45px",
                            padding: "0 35px",
                            justifyContent: "center",
                            "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                paddingTop: "2px",
                                "& .textSave": {
                                    display: "inline-block",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    paddingLeft: "13px"
                                },
                                "& .textSaveTwo": {
                                    paddingLeft: "0",
                                    "& .textSaveSpan": {
                                        color: "rgba(0, 200, 83, 1)"
                                    }
                                }
                            },
                        },
                    }}
                />
            </Backdrop>

            {/* ======================= */}
            {/* ===== FOR REJECT ====== */}
            {/* ======================= */}

            <Backdrop
                open={rejectSnack}
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                onClick={handleRejectClose}
            >
                <Snackbar
                    open={rejectSnack}
                    autoHideDuration={100000}
                    onClose={handleRejectClose}
                    message={
                        <>
                            <CircularProgress size={20} thickness={7} color="inherit" />
                            <span className='textSave'>Saving</span>
                            {/* <p className='textSave textSaveTwo'>Video   <span className='textSaveSpanDanger'> Rejected</span> -  Pending Verification</p> */}
                        </>
                    }
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    ContentProps={{
                        sx: {
                            minWidth: "219px !important",
                            background: "#000",
                            boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                            height: "45px",
                            padding: "0 35px",
                            justifyContent: "center",
                            "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                paddingTop: "2px",
                                "& .textSave": {
                                    display: "inline-block",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    paddingLeft: "13px"
                                },
                                "& .textSaveTwo": {
                                    paddingLeft: "0",
                                    "& .textSaveSpanDanger": {
                                        color: "#FF1744"
                                    }
                                }
                            },
                        },
                    }}
                />
            </Backdrop>

            {/* ============================ */}
            {/* ===== FOR WEBSITEONLY ====== */}
            {/* ============================ */}

            <Backdrop
                open={websiteonlySnack}
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                onClick={handleWebsiteonlyClose}
            >
                <Snackbar
                    open={websiteonlySnack}
                    autoHideDuration={100000}
                    onClose={handleWebsiteonlyClose}
                    message={
                        <>
                            <CircularProgress size={20} thickness={7} color="inherit" />
                            <span className='textSave'>Saving</span>
                            {/* <p className='textSave textSaveTwo'>Video Approved for <span className='textSaveSpanPurple'> Website Only</span>  Posting - Pending Verification</p> */}
                        </>
                    }
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    ContentProps={{
                        sx: {
                            minWidth: "219px !important",
                            background: "#000",
                            boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                            height: "45px",
                            padding: "0 35px",
                            justifyContent: "center",
                            "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                paddingTop: "2px",
                                "& .textSave": {
                                    display: "inline-block",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    paddingLeft: "13px"
                                },
                                "& .textSaveTwo": {
                                    paddingLeft: "0",
                                    "& .textSaveSpanPurple": {
                                        color: "#AB47BC"
                                    }
                                }
                            },
                        },
                    }}
                />
            </Backdrop>

            {/* ======================================== */}
            {/* ===== FOR REJECTION JUSTIFICATION ====== */}
            {/* ======================================== */}

            <Backdrop
                open={rejectJustificationSnack}
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                onClick={handleRejectJustificationClose}
            >
                <Snackbar
                    open={rejectJustificationSnack}
                    autoHideDuration={100000}
                    onClose={handleRejectJustificationClose}
                    message={
                        <>
                            <CircularProgress size={20} thickness={7} color="inherit" />
                            <span className='textSave'>Saving</span>
                        </>
                    }
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    ContentProps={{
                        sx: {
                            minWidth: "219px !important",
                            background: "#000",
                            boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                            height: "45px",
                            padding: "0 35px",
                            justifyContent: "center",
                            "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                paddingTop: "2px",
                                "& .textSave": {
                                    display: "inline-block",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    paddingLeft: "13px"
                                },
                                "& .textSaveTwo": {
                                    paddingLeft: "0",
                                    "& .textSaveSpanDanger": {
                                        color: "#FF1744"
                                    }
                                }
                            },
                        },
                    }}
                />
            </Backdrop>


            {/* ======================================== */}
            {/* ======== FOR VIDEO DUPLICATION ========= */}
            {/* ======================================== */}

            <Backdrop
                open={vdoduplicationSnack}
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                onClick={handlevdoduplicationSnackClose}
            >
                <Snackbar
                    open={vdoduplicationSnack}
                    autoHideDuration={100000}
                    onClose={handlevdoduplicationSnackClose}
                    message={
                        <>
                            <CircularProgress size={20} thickness={7} color="inherit" />
                            <span className='textSave'>Saving</span>
                            {/* <p>Video Flagged as Duplicate</p>  */} {/* if Yes*/}
                            {/* <p>Video Marked as Not a Duplicate</p>  */} {/* if No*/}
                        </>
                    }
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    ContentProps={{
                        sx: {
                            minWidth: "219px !important",
                            background: "#000",
                            boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                            height: "45px",
                            padding: "0 35px",
                            justifyContent: "center",
                            "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                paddingTop: "2px",
                                "& .textSave": {
                                    display: "inline-block",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    paddingLeft: "13px"
                                },
                                "& .textSaveTwo": {
                                    paddingLeft: "0",
                                    "& .textSaveSpanDanger": {
                                        color: "#FF1744"
                                    }
                                }
                            },
                        },
                    }}
                />
            </Backdrop>
        </>
    )
}
